import { Component } from '@angular/core';
import { E5coreUiWorkFieldTypeListBaseComponent } from './e5core-ui-work-field-type-list-base';

@Component({
  selector: 'e5core-ui-work-field-type-list-box',
  templateUrl: './e5core-ui-work-field-type-list-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-list-box.component.css']
})
export class E5coreUiWorkFieldTypeListBoxComponent extends E5coreUiWorkFieldTypeListBaseComponent {
}
